const Typography = require("typography")
const typography = new Typography()
module.exports = typography


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 336
// module chunks = 231608221292675